// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2MHbt","listWrap":"index_listWrap_1_7qn"};